const checkEmailFormat = (emailField: string) => {
  const reg = /^(?!.*\.\.)[A-Za-z0-9_\-.+]+@[A-Za-z0-9_\-.]+\.[A-Za-z]{2,4}$/;

  return reg.test(emailField);
};

export default checkEmailFormat;
